module.exports = __webpack_public_path__ + "fb08027f00961e77e7531e28d6e1eef4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-28.png
// module id = 3012
// module chunks = 0